import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-shovel-graph-table-popup',
  templateUrl: './shovel-graph-table-popup.component.html',
  styleUrls: ['./shovel-graph-table-popup.component.scss']
})
export class ShovelGraphTablePopupComponent implements OnInit {
tableData:any;
CompartTypeName:string;
 constructor( @Inject(MAT_DIALOG_DATA) private _data: any, public dialogRef: MatDialogRef<ShovelGraphTablePopupComponent>) { }

  ngOnInit(): void {
     this.tableData= this._data.tableData;
    this.CompartTypeName= this._data.title;
  }
onNoClick(){
  this.dialogRef.close();
}
}
